import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProductReveal() {
  const features = ['Protocolos de emergencia para ansiedad y pánico en 5 minutos', 'Sistema de sueño profundo sin pastillas ni suplementos', 'Frecuencias para Deep Work y concentración máxima', 'Limpieza vibracional de tu hogar y espacio de trabajo', 'Sanación del dolor físico, tensión y fatiga crónica', 'Plan de transformación de 90 días con checkpoints', 'Todo en 5 a 20 minutos por día, en cualquier lugar'];
  return <section className="py-8 md:py-20 px-4 max-w-5xl mx-auto text-center relative" data-id="element-376">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-64 bg-[#7c3aed]/10 blur-[100px] rounded-full pointer-events-none" data-id="element-377"></div>

      <FadeIn data-id="element-378">
        <motion.div animate={{
        y: [0, -10, 0]
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="inline-block mb-3 md:mb-8 relative" data-id="element-379">
          <div className="absolute inset-0 bg-[#7c3aed]/20 blur-2xl rounded-full" data-id="element-380"></div>
          <span className="text-5xl md:text-8xl relative z-10 drop-shadow-[0_0_30px_rgba(124,58,237,0.5)]" data-id="element-381">
            🎵
          </span>
        </motion.div>

        <h2 className="text-3xl md:text-7xl font-black mb-3 md:mb-8 text-transparent bg-clip-text bg-gradient-to-b from-[#5b21b6] via-[#7c3aed] to-[#a78bfa] tracking-tight drop-shadow-sm" data-id="element-382">
          BOTIQUÍN VIBRACIONAL PRO™
        </h2>

        <p className="text-base md:text-4xl font-bold text-[#1f1b16] mb-6 md:mb-14 max-w-3xl mx-auto leading-tight px-2" data-id="element-383">
          6 Tomos + 6 Bonos · Todo lo que necesitás para regular tu sistema
          nervioso, transformar tu sueño y sanar tu cuerpo.
        </p>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-384">
        <div className="bg-[#faf7f2] border border-[#e7dfce] rounded-2xl md:rounded-3xl p-5 md:p-12 max-w-3xl mx-auto text-left shadow-[0_20px_40px_rgba(124,58,237,0.1)] relative overflow-hidden" data-id="element-385">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#5b21b6] via-[#7c3aed] to-[#5b21b6]" data-id="element-386"></div>

          <ul className="space-y-3 md:space-y-6 relative z-10" data-id="element-387">
            {features.map((feature, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: index * 0.1
          }} viewport={{
            once: true
          }} className="flex items-center gap-3 md:gap-4" data-id="element-388">
                <div className="bg-[#7c3aed]/10 p-1.5 md:p-2 rounded-full border border-[#7c3aed]/20 shrink-0" data-id="element-389">
                  <CheckCircle2 className="text-[#7c3aed] w-5 h-5 md:w-7 md:h-7" strokeWidth={2.5} data-id="element-390" />
                </div>
                <span className="text-sm md:text-2xl text-[#1f1b16] font-bold" data-id="element-391">
                  {feature}
                </span>
              </motion.li>)}
          </ul>
        </div>
      </FadeIn>
    </section>;
}